import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './Navbar.css';

import DropdownProducts from './DropdownProducts';
import DropdownLanguage from './DropdownLanguage';
import DropdownAboutUs from './DropdownAboutUs';

import { FaGlobe } from 'react-icons/fa';   // 🌍 Added icon

import LatenaLogo from '../assets/logo-for-dark.svg';
import { useTranslation } from 'react-i18next';
import '../i18n';

function Navbar() {
  const { t, i18n } = useTranslation();

  const [click, setClick] = useState(false);
  const [dropdownProducts, setDropdownProducts] = useState(false);
  const [dropdownLanguage, setDropdownLanguage] = useState(false);
  const [dropdownAboutUs, setDropdownAboutUs] = useState(false);

  // Toggle mobile menu
  const handleClick = () => setClick(!click);

  // Close the menu completely
  const closeMobileMenu = () => setClick(false);

  const closeAllDropdowns = () => {
    setDropdownProducts(false);
    setDropdownLanguage(false);
    setDropdownAboutUs(false);
  };

  // Product dropdown
  const toggleDropdownProducts = () => {
    setDropdownProducts(!dropdownProducts);
    setDropdownLanguage(false);
    setDropdownAboutUs(false);
  };

  // Language dropdown
  const toggleDropdownLanguage = () => {
    setDropdownLanguage(!dropdownLanguage);
    setDropdownProducts(false);
    setDropdownAboutUs(false);
  };

  // About us dropdown
  const toggleDropdownAboutUs = () => {
    setDropdownAboutUs(!dropdownAboutUs);
    setDropdownProducts(false);
    setDropdownLanguage(false);
  };

  // Close menu when language changes
  useEffect(() => {
    const handleLanguageChange = () => {
      if (click) closeMobileMenu();
      closeAllDropdowns();
    };

    i18n.on('languageChanged', handleLanguageChange);
    return () => i18n.off('languageChanged', handleLanguageChange);
  }, [click, i18n]);

  return (
    <nav className="navbar">
      <Link to="/#main" className="navbar-logo" onClick={closeMobileMenu}>
        <img src={LatenaLogo} width="70" alt="AO Latena" />
      </Link>

      {/* Mobile burger */}
      <div className="menu-icon" onClick={handleClick}>
        <i className={click ? 'fas fa-times' : 'fas fa-bars'} />
      </div>

      {/* Navigation menu */}
      <ul className={click ? 'nav-menu active' : 'nav-menu'}>

        <li className="nav-item">
          <Link to="/" className="nav-links" onClick={closeMobileMenu}>
            {t('navbar.home')}
          </Link>
        </li>

        <li className="nav-item" onClick={toggleDropdownProducts}>
          <span className="nav-links">
            {t('navbar.products')} <i className="fas fa-caret-down" />
          </span>
          {dropdownProducts && <DropdownProducts closeMenu={closeMobileMenu} />}
        </li>

        <li className="nav-item" onClick={toggleDropdownAboutUs}>
          <span className="nav-links">
            {t('navbar.about_us')} <i className="fas fa-caret-down" />
          </span>
          {dropdownAboutUs && <DropdownAboutUs closeMenu={closeMobileMenu} />}
        </li>

        <li className="nav-item">
          <Link to="/career#main" className="nav-links" onClick={closeMobileMenu}>
            {t('navbar.career')}
          </Link>
        </li>

        {/* 🌍 Language Menu */}
        <li className="nav-item" onClick={toggleDropdownLanguage}>
          <span className="nav-links">
            <FaGlobe style={{ marginRight: '8px', marginBottom: '-2px' }} />
            {t('navbar.language')} <i className="fas fa-caret-down" />
          </span>
          {dropdownLanguage && <DropdownLanguage closeMenu={closeMobileMenu} />}
        </li>
      </ul>
    </nav>
  );
}

export default Navbar;
